import React from 'react';

function SideTextComponent() {
  return (
    <section className='absolute top-[63vh] left-1/2 transform -translate-x-1/2 lg:top-1/2 lg:left-8 lg:rotate-90 h-fit'>
      <ul className='grid justify-center text-colour3 mx-auto text-center lg:grid-flow-col lg:gap-8 text-lg lg:text-2xl h-fit tracking-widest font-atop w-full'>
        <li title='Videos' className='text__stroke'>
          Videos
        </li>
        <li title='Games' className='text__stroke'>
          Games
        </li>
        <li title='Pictures' className='text__stroke'>
          Pictures
        </li>
      </ul>
    </section>
  );
}

export default SideTextComponent;
